'use strict';

var Constants = require('../constants/constants');

// Constructor
var VisitMap = function() {

  var self = this;

  self.initMap = function() {

    // https://developers.google.com/maps/documentation/javascript/reference#MapOptions
    var mapOptions = {
      backgroundColor: '#eee',
      disableDefaultUI: false,
      mapTypeControl: false,
      streetViewControl: false,
      zoomControlOptions: {
        position: google.maps.ControlPosition.LEFT_BOTTOM
      },
      scrollwheel: false,
      zoom: 12,
      center: new google.maps.LatLng(39.5550817, 2.6100569999999834),
      // https://snazzymaps.com/style/151/ultra-light-with-labels
      styles: new Constants().MAP_STYLES
    };
    var mapElement = document.getElementById('visitMapElement');
    var map = new google.maps.Map(mapElement, mapOptions);
    var infowindow = new google.maps.InfoWindow();
    var service = new google.maps.places.PlacesService(map);
    service.getDetails({
      placeId: 'ChIJ18E5B_KNlxIRRnYzOJYHB_A'
    }, function(place, status) {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        var marker = new google.maps.Marker({
          map: map,
          icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAbCAMAAABLAV/qAAAAMFBMVEVMaXHx8/n///////////////////////9HYKf///9PZ6uImMZhdrSqtdfV2uvAyOGSJaddAAAACHRSTlMA+pB0sk8ZL5qxv9cAAAC3SURBVHjaZZFREsQgCEOhaCsF9f63XUvWrc6+n04DyQgQyIlVOWV6Ee3mpbh1lakdbSjA2/HVelnooUorG+1JUN9FV6IM812Z642ATMlg0gGCLBFH2TSwMDFpVCvEGj9K+t+plBwWHSDKEwks3lSbI0roRHk0zy+fRIeVDXvmvGbrbLxiIXUVK9Z0si+Tj8RA+rI5IYD559yTzL/nZChY/rr2PQDmJeC55mrGpXCdnaPi2Tvy9n0Ai6QMQQtz3gQAAAAASUVORK5CYII=',
          position: place.geometry.location
        });
        google.maps.event.addListener(marker, 'click', function() {
          infowindow.setContent('<strong>' + place.name + '</strong>' + '<br>' + place.formatted_address);
          infowindow.open(map, this);
        });
        google.maps.event.addDomListener(window, 'resize', function() {
          map.setCenter(place.geometry.location);
        });
      }
    });
  }


  self.init = function() {
    $(window).on('gMapsReady', function() {
      $(window).trigger('gMapsStopPolling');
      self.initMap();
    });
  }
};

module.exports = VisitMap;
